var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        "append-to-body": "",
        "custom-class": "",
        "close-on-click-modal": false,
        visible: _vm.innerVisible,
        title: _vm.$t("Payment.contactPerson"),
        width: "400px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.cancel
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-bottom": "10px" }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                "label-width": "90px",
                "label-position": "left"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.contactPerson") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { disabled: true, no: "1" },
                        model: {
                          value: _vm.contact.contactPerson,
                          callback: function($$v) {
                            _vm.$set(_vm.contact, "contactPerson", $$v)
                          },
                          expression: "contact.contactPerson"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Role") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { disabled: true, no: "2" },
                        model: {
                          value: _vm.contact.role,
                          callback: function($$v) {
                            _vm.$set(_vm.contact, "role", $$v)
                          },
                          expression: "contact.role"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Tel") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { disabled: true, no: "3" },
                        model: {
                          value: _vm.contact.telephone,
                          callback: function($$v) {
                            _vm.$set(_vm.contact, "telephone", $$v)
                          },
                          expression: "contact.telephone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Mobile") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { disabled: true, no: "4" },
                        model: {
                          value: _vm.contact.mobile,
                          callback: function($$v) {
                            _vm.$set(_vm.contact, "mobile", $$v)
                          },
                          expression: "contact.mobile"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Fax") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { disabled: true, no: "5" },
                        model: {
                          value: _vm.contact.fax,
                          callback: function($$v) {
                            _vm.$set(_vm.contact, "fax", $$v)
                          },
                          expression: "contact.fax"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.emailAddress2") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: { disabled: true, no: "6" },
                        model: {
                          value: _vm.contact.email,
                          callback: function($$v) {
                            _vm.$set(_vm.contact, "email", $$v)
                          },
                          expression: "contact.email"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.remarks") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          type: "textarea",
                          rows: 5,
                          disabled: true,
                          no: "7"
                        },
                        model: {
                          value: _vm.contact.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.contact, "remarks", $$v)
                          },
                          expression: "contact.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }